<template>
  <div
    class="viluu-landing viluu-cmp"
    :class="{ 'is-leaving': isLeaving, 'from-bfcache': fromBfcache }"
  >
    <the-nav variant="subpage" />

    <div class="cmp-wrap">
      <div class="container">
        <div class="pill">Inhaltsmoderation</div>

        <article
          class="content-moderation-policy"
          lang="de"
        >
          <h1>Richtlinie zur Inhaltsüberwachung</h1>

          <nav
            class="toc"
            aria-label="Inhaltsverzeichnis"
          >
            <ol>
              <li><a href="/cmp#par-1">§ 1 Zweck und Geltungsbereich</a></li>
              <li><a href="/cmp#par-2">§ 2 Rechtlicher Rahmen</a></li>
              <li><a href="/cmp#par-3">§ 3 Inhalte, die der Überwachung unterliegen</a></li>
              <li><a href="/cmp#par-4">§ 4 Methoden der Inhaltsüberwachung</a></li>
              <li><a href="/cmp#par-5">§ 5 Rollen und Verantwortlichkeiten</a></li>
              <li><a href="/cmp#par-6">§ 6 Inhalte, die gegen die Regeln verstoßen</a></li>
              <li><a href="/cmp#par-7">§ 7 Eskalationsverfahren</a></li>
              <li><a href="/cmp#par-8">§ 8 Meldung von Inhalten durch Nutzer</a></li>
              <li><a href="/cmp#par-9">§ 9 Moderationsmaßnahmen</a></li>
              <li><a href="/cmp#par-10">§ 10 Kinderschutz</a></li>
              <li><a href="/cmp#par-11">§ 11 Beschwerde- und Widerspruchsverfahren</a></li>
              <li><a href="/cmp#par-12">§ 12 Datenschutz</a></li>
              <li><a href="/cmp#par-13">§ 13 Transparenz und Dokumentation</a></li>
              <li><a href="/cmp#par-14">§ 14 Aktualisierung dieser Richtlinie</a></li>
            </ol>
          </nav>

          <section id="par-1">
            <h2>§ 1 Zweck und Geltungsbereich</h2>
            <p>
              Diese Richtlinie beschreibt, wie die We2Gether GmbH (nachfolgend „Betreiber“) Inhalte auf der
              Viluu-Plattform prüft, verwaltet und moderiert. Ziel ist es, ein sicheres Umfeld für alle Nutzer
              zu gewährleisten, geltende Gesetze einzuhalten – insbesondere den Digital Services Act (DSA), die
              DSGVO sowie das nationale deutsche Recht – und rechtswidrige oder schädliche Inhalte zu verhindern.
            </p>
            <p>Diese Richtlinie gilt für nutzergenerierte Inhalte auf Viluu, insbesondere:</p>
            <ul>
              <li>Profilbilder,</li>
              <li>„Über mich“-Texte und Profilangaben,</li>
              <li>Nutzernamen,</li>
              <li>durch Nutzer gemeldete Inhalte und Interaktionen.</li>
            </ul>
            <p>
              Private Chatnachrichten werden nicht routinemäßig eingesehen. Eine Prüfung erfolgt ausschließlich
              bei einer Meldung durch Nutzer oder bei Hinweisen auf schwerwiegende Rechtsverstöße gemäß den
              gesetzlichen Anforderungen.
            </p>
          </section>

          <section id="par-2">
            <h2>§ 2 Rechtlicher Rahmen</h2>
            <p>Die Inhaltsüberwachung erfolgt im Einklang mit:</p>
            <ul>
              <li>EU Digital Services Act (DSA),</li>
              <li>Datenschutz-Grundverordnung (DSGVO),</li>
              <li>Jugendmedienschutz-Staatsvertrag (JMStV),</li>
              <li>anwendbarem nationalem Recht (Deutschland / EU),</li>
              <li>den Nutzungsbedingungen und der Datenschutzerklärung von Viluu.</li>
            </ul>
            <p>
              Alle Maßnahmen erfolgen verhältnismäßig, transparent und unter Achtung der Grundrechte,
              insbesondere Meinungsfreiheit und Datenschutz.
            </p>
          </section>

          <section id="par-3">
            <h2>§ 3 Inhalte, die der Überwachung unterliegen</h2>
            <p>Folgende Inhalte werden automatisiert und/oder manuell geprüft:</p>
            <ul>
              <li>Neu hochgeladene Profilbilder,</li>
              <li>neu erstellte oder geänderte „Über mich“-Texte,</li>
              <li>Nutzernamen,</li>
              <li>durch Nutzer gemeldete Inhalte und Profile.</li>
            </ul>
          </section>

          <section id="par-4">
            <h2>§ 4 Methoden der Inhaltsüberwachung</h2>

            <h3>4.1 Automatisierte Prüfung</h3>
            <p>
              Alle neu hochgeladenen Profilbilder sowie neu erstellte oder geänderte „Über mich“-Texte und
              Nutzernamen werden unmittelbar nach Einreichung automatisch geprüft. Dabei kommen technische
              Systeme zur Erkennung potenzieller Regelverstöße zum Einsatz. Inhalte, die als möglicherweise
              regelwidrig eingestuft werden, werden zur manuellen Prüfung an das interne Moderationsteam
              weitergeleitet.
            </p>
            <p>
              Automatisierte Systeme werden regelmäßig auf Qualität überprüft und so gestaltet, dass
              Fehlbewertungen minimiert werden.
            </p>

            <h3>4.2 Manuelle Prüfung</h3>
            <p>
              Das interne Moderationsteam prüft alle automatisch markierten sowie alle durch Nutzer gemeldeten
              Inhalte. Jede Prüfung wird objektiv, unparteiisch und auf Grundlage folgender Kriterien
              durchgeführt:
            </p>
            <ul>
              <li>geltende Gesetze,</li>
              <li>Nutzungsbedingungen von Viluu,</li>
              <li>interne Moderationsrichtlinien,</li>
              <li>verfügbare Inhalte und ergänzende Informationen.</li>
            </ul>
            <p>
              Persönliche Meinungen oder subjektive Einschätzungen fließen nicht in Entscheidungen ein. Jede
              Prüfung endet mit einem der folgenden Ergebnisse: kein Verstoß festgestellt, Verstoß bestätigt
              oder Eskalation erforderlich.
            </p>
          </section>

          <section id="par-5">
            <h2>§ 5 Rollen und Verantwortlichkeiten</h2>
            <dl>
              <dt>Management</dt>
              <dd>
                Legt die strategische Ausrichtung der Inhaltsüberwachung fest, definiert Risikotoleranz und
                stellt die erforderlichen Ressourcen bereit. Trägt die Gesamtverantwortung für die Einhaltung
                geltender gesetzlicher Anforderungen.
              </dd>

              <dt>Moderationsteam</dt>
              <dd>
                Prüft gemeldete und automatisch markierte Inhalte, wendet diese Richtlinie sowie die internen
                Moderationsrichtlinien konsistent an und dokumentiert alle Entscheidungen nachvollziehbar.
              </dd>

              <dt>Senior-Mitarbeitende</dt>
              <dd>
                Bearbeiten eskalierte, sensible oder rechtlich komplexe Fälle. Ausschließlich sie sind
                berechtigt, auf Chatnachrichten zuzugreifen und Meldungen an externe Behörden oder
                Strafverfolgungsbehörden weiterzuleiten.
              </dd>

              <dt>Datenschutzbeauftragte/r (sofern bestellt)</dt>
              <dd>
                Überwacht die Einhaltung datenschutzrechtlicher Anforderungen im Rahmen der Inhaltsüberwachung
                und steht als Ansprechpartner für datenschutzbezogene Fragen zur Verfügung.
              </dd>

              <dt>Externe Dienstleister</dt>
              <dd>
                Soweit externe Dritte in die Inhaltsmoderation eingebunden sind, erfolgt dies ausschließlich auf
                Grundlage vertraglicher Vereinbarungen, die Vertraulichkeit, Datenschutz und die Einhaltung
                dieser Richtlinie sicherstellen.
              </dd>
            </dl>
          </section>

          <section id="par-6">
            <h2>§ 6 Inhalte, die gegen die Regeln verstoßen</h2>
            <p>Inhalte werden als Verstoß bewertet, wenn sie unter anderem:</p>
            <ul>
              <li>sexuellen Kindesmissbrauch oder Ausbeutung von Kindern darstellen oder fördern,</li>
              <li>Kinder gefährden,</li>
              <li>terroristische oder extremistische Inhalte enthalten,</li>
              <li>Gewalt androhen oder zu Straftaten aufrufen,</li>
              <li>Hassrede oder diskriminierende Inhalte enthalten,</li>
              <li>andere Nutzer belästigen, beleidigen oder bedrohen,</li>
              <li>betrügerische oder täuschende Inhalte beinhalten,</li>
              <li>pornografische oder jugendgefährdende Inhalte enthalten,</li>
              <li>Urheberrechte, Markenrechte, Persönlichkeitsrechte oder Datenschutzrechte verletzen,</li>
              <li>gegen geltendes Recht oder die Nutzungsbedingungen von Viluu verstoßen.</li>
            </ul>
          </section>

          <section id="par-7">
            <h2>§ 7 Eskalationsverfahren</h2>
            <p>
              Bestimmte Fälle werden ausschließlich durch erfahrene Mitarbeitende (Senior-Ebene) bearbeitet.
              Dazu zählen insbesondere:
            </p>
            <ul>
              <li>Meldungen zu Chatnachrichten,</li>
              <li>Verdacht auf sexuellen Kindesmissbrauch oder Kinderausbeutung,</li>
              <li>terroristische oder extremistische Inhalte,</li>
              <li>glaubwürdige Gewaltandrohungen,</li>
              <li>Inhalte, die eine gesetzliche Meldepflicht auslösen können,</li>
              <li>Anfragen von Strafverfolgungsbehörden oder gerichtliche Anordnungen.</li>
            </ul>
            <p>
              Ausschließlich autorisierte Mitarbeitende der Senior-Ebene sind berechtigt, auf Chatnachrichten
              zuzugreifen oder Meldungen an externe Behörden weiterzuleiten.
            </p>
          </section>

          <section id="par-8">
            <h2>§ 8 Meldung von Inhalten durch Nutzer</h2>
            <p>
              Nutzer können Inhalte und Verhalten auf Viluu über die in der App vorgesehenen Meldefunktionen
              oder per E-Mail an <a href="mailto:support@viluu.de">support@viluu.de</a> melden. Jede Meldung
              wird einzeln geprüft, unabhängig davon, ob der Inhalt bereits automatisiert überprüft wurde.
            </p>
            <p>Für eine schnelle Bearbeitung sollte die Meldung nach Möglichkeit folgende Angaben enthalten:</p>
            <ul>
              <li>den gemeldeten Inhalt oder das betroffene Profil,</li>
              <li>den Grund der Meldung,</li>
              <li>eine kurze Beschreibung des Vorfalls,</li>
              <li>ergänzende Informationen oder Screenshots, soweit vorhanden.</li>
            </ul>
            <p>
              Das Meldesystem dient ausschließlich der Meldung tatsächlicher oder vermuteter Verstöße.
              Vorsätzlich falsche Meldungen können selbst einen Verstoß gegen die Nutzungsbedingungen darstellen.
            </p>
          </section>

          <section id="par-9">
            <h2>§ 9 Moderationsmaßnahmen</h2>
            <p>Je nach Art und Schwere eines Verstoßes können folgende Maßnahmen ergriffen werden:</p>
            <ul>
              <li>Ablehnung oder Entfernung des betreffenden Inhalts,</li>
              <li>Verwarnung des Nutzers,</li>
              <li>temporäre Einschränkung von Kontofunktionen,</li>
              <li>temporäre Kontosperrung,</li>
              <li>dauerhafte Kontoschließung,</li>
              <li>Weiterleitung an zuständige Behörden, soweit gesetzlich erforderlich.</li>
            </ul>
            <p>
              Maßnahmen erfolgen verhältnismäßig und orientieren sich an Schweregrad, Kontext und etwaiger
              Wiederholung.
            </p>
          </section>

          <section id="par-10">
            <h2>§ 10 Kinderschutz</h2>
            <p>
              Inhalte, die Kinder gefährden oder sexuellen Kindesmissbrauch darstellen oder fördern, werden mit
              höchster Priorität behandelt. Bestätigte Verstöße führen zur sofortigen Entfernung der Inhalte und
              zur Sperrung des betroffenen Kontos. Soweit gesetzlich erforderlich, erfolgt eine Meldung an die
              zuständigen Behörden, einschließlich des National Center for Missing and Exploited Children
              (NCMEC) oder entsprechender lokaler Stellen.
            </p>
            <p>
              Für alle Angelegenheiten zum Schutz von Kindern hat der Betreiber einen Jugendschutzbeauftragten
              benannt. Dieser ist erreichbar unter:
              <a href="mailto:info@jugendschutzbeauftragter.com">info@jugendschutzbeauftragter.com</a>
            </p>
          </section>

          <section id="par-11">
            <h2>§ 11 Beschwerde- und Widerspruchsverfahren</h2>
            <p>
              Nutzer, die von einer Moderationsentscheidung betroffen sind – beispielsweise durch die Entfernung
              von Inhalten oder die Einschränkung ihres Kontos –, haben das Recht, diese Entscheidung
              anzufechten.
            </p>
            <p>
              Beschwerden können per E-Mail eingereicht werden an:
              <a href="mailto:support@viluu.de">support@viluu.de</a>
            </p>
            <p>
              Jede Beschwerde wird von einer qualifizierten Person geprüft, die nicht an der ursprünglichen
              Entscheidung beteiligt war. Eingehende Beschwerden werden innerhalb von 72 Stunden bearbeitet.
              Der Nutzer wird über das Ergebnis der Prüfung informiert.
            </p>
            <p>Dieses Verfahren lässt weitergehende rechtliche Rechtsmittel unberührt.</p>
          </section>

          <section id="par-12">
            <h2>§ 12 Datenschutz</h2>
            <p>
              Die Verarbeitung personenbezogener Daten im Rahmen der Inhaltsüberwachung erfolgt gemäß der DSGVO
              und der Datenschutzerklärung von Viluu. Der Zugriff auf personenbezogene Daten und
              Moderationsdokumentation ist auf autorisierte Mitarbeitende beschränkt. Alle Informationen aus dem
              Prüfverfahren werden vertraulich behandelt.
            </p>
          </section>

          <section id="par-13">
            <h2>§ 13 Transparenz und Dokumentation</h2>
            <p>
              Der Betreiber führt interne Dokumentation zu Moderationsentscheidungen, eingesetzten
              automatisierten Systemen sowie Schulung und Qualitätssicherung des Moderationsteams. Soweit
              gesetzlich erforderlich, werden Transparenzpflichten nach dem DSA erfüllt.
            </p>
          </section>

          <section id="par-14">
            <h2>§ 14 Aktualisierung dieser Richtlinie</h2>
            <p>
              Diese Richtlinie wird regelmäßig überprüft und bei Bedarf angepasst, insbesondere bei
              Gesetzesänderungen, Produktänderungen oder neuen Risiken.
            </p>
          </section>
        </article>
      </div>
    </div>

    <the-footer variant="legal" />
    <signup-modal />
    <cookie-banner />
  </div>
</template>

<script>
import { landingChromeMixin } from '../landingChrome';
import CookieBanner from '../../../../components/LandingV2/CookieBanner.vue';
import TheNav from '../../../../components/LandingV2/sections/TheNav.vue';
import TheFooter from '../../../../components/LandingV2/sections/TheFooter.vue';
import SignupModal from '../../../../components/LandingV2/signup/SignupModal.vue';

export default {
  name: 'CmpPage',
  mixins: [landingChromeMixin],
  components: { CookieBanner, TheNav, TheFooter, SignupModal },
};
</script>

<style scoped lang="scss">
/* Content Moderation Policy — same chrome / palette pattern as CSAE. */
.viluu-cmp {
  --cmp-bg-cream: #fdf6f0;
  --cmp-ink: #1a0c14;
  --cmp-body-text: #6b4955;
  --cmp-pink: #d44e85;
  --cmp-orange: #f0944a;
  --cmp-pill-bg: #f7e1ea;
  --cmp-pill-text: #c2386f;
  --cmp-card-border: #f3e3ea;

  position: relative;
  min-height: 100vh;
  background:
    radial-gradient(circle at 15% 0%, rgba(240, 148, 74, 0.2), transparent 45%),
    radial-gradient(circle at 85% 10%, rgba(212, 78, 133, 0.18), transparent 50%),
    var(--cmp-bg-cream);
}

.cmp-wrap {
  position: relative;
  overflow: hidden;
  padding: 56px 24px 80px;
}

.container {
  max-width: 760px;
  margin: 0 auto;
  font-family: 'Inter Tight', system-ui, sans-serif;
  color: var(--cmp-body-text);
  line-height: 1.6;
}

.container *,
.container *::before,
.container *::after {
  box-sizing: border-box;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--cmp-pill-bg);
  color: var(--cmp-pill-text);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 999px;
  margin-bottom: 20px;
}

.pill::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--cmp-pill-text);
  display: inline-block;
}

.container h1 {
  font-family: 'Bricolage Grotesque', system-ui, sans-serif;
  font-weight: 800;
  font-size: 42px;
  line-height: 1.1;
  color: var(--cmp-ink);
  margin: 0 0 28px;
}

.toc {
  background: linear-gradient(135deg, #ffffff, #fdeef2);
  border: 1px solid var(--cmp-card-border);
  border-radius: 20px;
  padding: 22px 28px;
  margin: 0 0 44px;
  box-shadow: 0 4px 24px rgba(212, 78, 133, 0.08);
}

.toc ol {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.toc li {
  font-size: 15.5px;
  color: var(--cmp-body-text);
  margin-bottom: 8px;
}

.toc li:last-child {
  margin-bottom: 0;
}

.toc a {
  color: var(--cmp-pink);
  text-decoration: none;
  font-weight: 600;
}

.toc a:hover {
  text-decoration: underline;
}

.container section {
  scroll-margin-top: 96px;
}

.container h2 {
  font-family: 'Bricolage Grotesque', system-ui, sans-serif;
  font-weight: 700;
  font-size: 26px;
  color: var(--cmp-ink);
  margin: 44px 0 14px;
}

.container h3 {
  font-family: 'Bricolage Grotesque', system-ui, sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: var(--cmp-ink);
  margin: 28px 0 10px;
}

.container p {
  font-size: 17px;
  color: var(--cmp-body-text);
  margin: 0 0 16px;
}

.container ul {
  margin: 0 0 20px;
  padding-left: 22px;
}

.container li {
  font-size: 17px;
  color: var(--cmp-body-text);
  margin-bottom: 10px;
}

.container dl {
  margin: 0 0 20px;
}

.container dt {
  font-weight: 700;
  color: var(--cmp-ink);
  font-size: 17px;
  margin: 18px 0 6px;
}

.container dt:first-child {
  margin-top: 0;
}

.container dd {
  font-size: 17px;
  color: var(--cmp-body-text);
  margin: 0 0 0 0;
}

.container strong {
  color: var(--cmp-ink);
}

.container a {
  color: var(--cmp-pink);
}

@media (max-width: 640px) {
  .cmp-wrap {
    padding: 36px 18px 56px;
  }
  .container h1 {
    font-size: 30px;
    line-height: 1.12;
  }
  .pill {
    font-size: 12px;
    padding: 5px 12px;
    margin-bottom: 16px;
  }
  .toc {
    padding: 18px 20px;
    border-radius: 16px;
    margin-bottom: 32px;
  }
  .toc li {
    font-size: 14.5px;
  }
  .container h2 {
    font-size: 22px;
    margin: 32px 0 12px;
  }
  .container h3 {
    font-size: 18px;
  }
  .container p,
  .container li,
  .container dt,
  .container dd {
    font-size: 15.5px;
  }
  .container ul {
    padding-left: 18px;
  }
}

@media (max-width: 380px) {
  .container h1 {
    font-size: 26px;
  }
  .toc {
    padding: 16px;
  }
}
</style>
